import React from "react";
import BaseView from "../common/BaseView";
import { columns } from "./config";
import { getActiveLeads } from "../../../Api";
import withData from "../../Data/withData";

function View(props: any) {
  return (
    <BaseView
      columns={columns}
      title="Active Leads"
      subtitle="These are active companies that have not completed the
    application process."
      {...props}
    ></BaseView>
  );
}

export default withData(View, getActiveLeads);
